//removeIf(production)
var claroluz_data = {
    ajax_url: ''
}
//endRemoveIf(production)

class ClaroluzNotifyEmail {
    private email: string;
    private cups: string;

    constructor(email: string, cups: string) {
        this.email = email;
        this.cups = cups;
        
        this.sendNotification();
    }

    private async sendNotification() {
        await fetch(claroluz_data.ajax_url + '?action=claroluznotify', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({email: this.email, cups: this.cups})
        });
    }
}

//removeIf(production)
export default ClaroluzNotifyEmail;
//endRemoveIf(production)